import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=ec84d5ba"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports